import * as React from 'react';
import { Checkbox } from '../../Checkbox';
import { BasicLocationPickerLocation } from './types';

export type PickableLocationCheckboxProps = Pick<React.HTMLAttributes<any>, 'style'> & {
    item: BasicLocationPickerLocation;
    selected: ReadonlyArray<string>;
    disabled: ReadonlyArray<string>;
    onChange: (selected: string[]) => void;
};

export const PickableLocationCheckbox: React.FC<PickableLocationCheckboxProps> = ({
    disabled,
    item,
    onChange,
    selected,
    ...props
}) => {
    const isChecked = selected.includes(item.id);
    const isDisabled = disabled.includes(item.id);

    return (
        <Checkbox
            {...props}
            checked={isChecked}
            disabled={isDisabled}
            type="checkbox"
            onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                if (event.target.checked && !isChecked) {
                    onChange([...selected, item.id]);
                } else if (!event.target.checked) {
                    onChange(selected.filter(id => id !== item.id));
                }
            }}
        >
            <div>{item.title}</div>
        </Checkbox>
    );
};
PickableLocationCheckbox.displayName = 'PickableLocationCheckbox';
